<template>
  <div class="content">
    <div class="md-layout py-5">
      <div class="main_section">
        <h3 class="main_section-title">Payment</h3>
        <div class="main_section-content">
          <div class="main_details-content">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <stats-card data-background-color="green">
                  <template slot="header">
                    <md-icon>payments</md-icon>
                  </template>
                  <template slot="content">
                    <div class="stats_content w-100 py-3">
                      <form @submit.prevent="submitForm">
                        <md-icon>payments</md-icon>
                        <div class="md-layout w-100">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>First Name</label>
                              <md-input v-model="form.reservation.first_name" md-placeholder="First Name" required></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Last Name</label>
                              <md-input v-model="form.reservation.last_name" md-placeholder="Last Name" required></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Email</label>
                              <md-input v-model="form.reservation.email_address" type="email" md-placeholder="Email" required></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Phone</label>
                              <md-input v-model="form.reservation.phone_number" md-placeholder="Phone" required></md-input>
                            </md-field>
                          </div>
                        </div>

                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Billing Address</label>
                              <md-input v-model="form.billing.billing_address" md-placeholder="Billing Address" required></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>City</label>
                              <md-input v-model="form.billing.city" md-placeholder="City" required></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Country</label>
                              <md-select v-model="form.billing.country" required>
                                <md-option
                                    v-for="country in countries"
                                    :key="country.code"
                                    :value="country.code"
                                >
                                  {{ country.name }}
                                </md-option>
                              </md-select>
<!--                              <md-input v-model="form.billing.country" md-placeholder="Country"></md-input>-->
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Zip</label>
                              <md-input v-model="form.billing.zip_code" md-placeholder="Zip" required></md-input>
                            </md-field>
                          </div>
                        </div>
                        <!-- Stripe card element -->
                        <div id="card-element"></div>
                        <!-- Messages -->
                        <p v-if="errorMessage" class="text-danger mt-2">
                          {{ errorMessage }}
                        </p>
                        <p v-if="successMessage" class="text-success mt-2">
                          {{ successMessage }}
                        </p>
                        <!-- Pay button -->
                        <md-button
                            type="submit"
                            class="md-raised md-success"
                            :disabled="isSubmitting || !canSubmitForm"
                        >
                          {{ isSubmitting ? 'Processing...' : 'Pay' }}
                        </md-button>
                      </form>
                    </div>
                  </template>
                </stats-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import axios from 'axios'
import {StatsCard} from "@/components";

export default {
  name: "BookingPayment",
  components: {
    StatsCard
  },
  data() {
    return {
      form: {
        reservation: {
          first_name: '',
          last_name: '',
          email_address: '',
          phone_number: '',
          guests: 1,
          start_date: '',
          end_date: '',
        },
        billing: {
          billing_address: '',
          city: '',
          zip_code: '',
          country: '',
        }
      },
      countries: [],
      stripe: null,
      cardElement: null,
      errorMessage: '',
      successMessage: '',
      isSubmitting: false
    }
  },
  computed: {
    canSubmitForm() {
      const r = this.form.reservation
      const b = this.form.billing
      if (!r.first_name || !r.last_name || !r.email_address) return false
      return !(!b.billing_address || !b.city || !b.zip_code || !b.country);
    }
  },
  async mounted() {
    const stripeKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
    // this.stripe = await loadStripe('pk_live_51PxYv400ZtcVqVEy1IKW4yE0uOhyQDJGo1w0X7uAneSZA1Yia193QTVSn1EfrEqfM2lXXlhk6wsPRk3pcGDN7Gyx007DkTv1kf')
    this.stripe = await loadStripe(stripeKey)
    const elements = this.stripe.elements()
    this.cardElement = elements.create('card')
    this.cardElement.mount('#card-element')
    this.loadCountries()
  },
  methods: {
    async loadCountries() {
      try {
        // Free API with Countries codes and English names
        const res = await axios.get('https://countriesnow.space/api/v0.1/countries/iso')

        if (res.data && Array.isArray(res.data.data)) {
          this.countries = res.data.data
              .map(c => ({
                code: c.Iso2,
                name: c.name
              }))
              .filter(c => c.code && c.name)
              .sort((a, b) => a.name.localeCompare(b.name))
        } else {
          console.error('Unexpected countries API response', res.data)
          this.errorMessage =
              'Could not load the list of countries due to an unexpected response. Please refresh the page and try again.'
        }
      } catch (e) {
        console.error('Failed to load countries', e)
        this.errorMessage =
            'Could not load the list of countries. Please check your internet connection or try again later.'
      }
    },
    async submitForm() {
      this.errorMessage = ''
      this.successMessage = ''
      this.isSubmitting = true
      try {
        if (!this.canSubmitForm) {
          this.errorMessage =
              'Please fill in all required fields before making a payment.'
          this.isSubmitting = false
          return
        }
        if (!this.stripe || !this.cardElement) {
          this.errorMessage =
              'Payment form is not fully loaded yet. Please wait a moment and try again.'
          this.isSubmitting = false
          return
        }
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: `${this.form.reservation.first_name} ${this.form.reservation.last_name}`,
            address: {
              line1: this.form.billing.billing_address,
              city: this.form.billing.city,
              postal_code: this.form.billing.zip_code,
              country: this.form.billing.country // already ISO 2-letter code
            }
          }
        })
        if (error) {
          this.errorMessage =
              error.message ||
              'We could not create a payment method. Please check your card details and try again.'
          this.isSubmitting = false
          return
        }
        const payload = {
          reservation: this.form.reservation,
          billing: this.form.billing,
          stripe_payment_method_id: paymentMethod.id
        }
        await axios.post('/api/reservations', payload)
        this.successMessage =
            'Your reservation and payment were completed successfully.'
        this.errorMessage = ''
        this.resetForm()
      } catch (err) {
        console.error(err)
        if (err.response && err.response.data && err.response.data.message) {
          this.errorMessage = err.response.data.message
        } else {
          this.errorMessage =
              'Something went wrong while processing your payment. Please check your details and try again. If the problem continues, contact support.'
        }
      } finally {
        this.isSubmitting = false
      }
    },
    resetForm() {
      this.form.reservation.first_name = ''
      this.form.reservation.last_name = ''
      this.form.reservation.email_address = ''
      this.form.reservation.phone_number = ''
      this.form.reservation.guests = 1
      this.form.reservation.start_date = ''
      this.form.reservation.end_date = ''

      this.form.billing.billing_address = ''
      this.form.billing.city = ''
      this.form.billing.zip_code = ''
      this.form.billing.country = ''
    }

  }
}
</script>

<style scoped>
#card-element {
  border: 1px solid #ccc;
  padding: 12px;
  margin: 10px 0;
  border-radius: 6px;
}
</style>
